import { useRef } from 'react';
import { springs } from './engine';
import { useMotion } from './useMotion';

// An element with enter/exit springs, for use right in JSX:
//   <Motion {...presets.dropdown('top right')} className="…">…</Motion>
// Takes the useMotion options plus `as` (tag, default div); everything else goes to the element.
export function Motion({ as: Tag = 'div', enter, exit, parts, origin, config, exitConfig, ghost, force, ...props }) {
  const ref = useRef();
  useMotion(ref, { enter, exit, parts, origin, config, exitConfig, ghost, force });
  return <Tag ref={ref} {...props} />;
}

const fade = { enter: { opacity: 0 }, exit: { opacity: 0 } };

// Common motions, so the same kind of thing moves the same way everywhere
export const presets = {
  fade: { ...fade, config: springs.snappy },
  // Menus and dropdowns opening from their button
  dropdown: (origin = 'top right') => ({ enter: { y: -6, scale: 0.94, opacity: 0 }, exit: { scale: 0.97, opacity: 0 }, origin, config: springs.snappy }),
  // Overlay with [data-backdrop] that fades and a [data-card] that springs open
  dialog: {
    parts: {
      '[data-backdrop]': fade,
      '[data-card]': { enter: { y: 24, scale: 0.94, opacity: 0 }, exit: { scale: 0.96, opacity: 0 } },
    },
    config: springs.sheet,
  },
  // Small things appearing with a bounce (chips, badges, confirmations)
  pop: { enter: { scale: 0.85, opacity: 0 }, exit: { scale: 0.85, opacity: 0 }, config: springs.bouncy },
  // Page content coming in
  rise: { enter: { y: 18, opacity: 0 }, config: springs.smooth },
};
